/* eslint-disable */
import axios from "axios";
import Swal from "sweetalert2";

const apicache = async (account, productUrl) => {
  if (!account?.store || !account?.storeName) return;

  const domain = new URL(account?.storeName).hostname;
  const parts = domain.split(".");
  const subdomain = parts.length > 2 ? parts[0] : "";

  const cacheKey = productUrl; // ✅ منتج واحد فقط

  const requests = [];

  if (account?.storeName !== account?.store) {
    requests.push(
      axios.post(
        `${account?.storeName}api/revalidate?secret=iusdbviuOiuf14DJIU`,
        {
          slugs: [cacheKey],
          store: subdomain,
        }
      ),
      axios.post(`${account?.store}api/revalidate?secret=iusdbviuOiuf14DJIU`, {
        slugs: [cacheKey],
        store: subdomain,
      })
    );
  } else {
    requests.push(
      axios.post(`${account?.store}api/revalidate?secret=iusdbviuOiuf14DJIU`, {
        slugs: [cacheKey],
        store: subdomain,
      })
    );
  }

  try {
    const results = await Promise.allSettled(requests);
    const successful = results.filter((r) => r.status === "fulfilled");
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};

export default apicache;
